{
  "title": "ਆਪਣਾ ਟਿਕਾਣਾ ਸਾਂਝਾ ਕਰਨ ਨਾਲ ਚੈੱਕ-ਇਨ ਪ੍ਰਕਿਰਿਆ ਤੇਜ਼ ਹੋ ਜਾਂਦੀ ਹੈ",
  "body": "ਸਾਨੂੰ ਅਫ਼ਸੋਸ ਹੈ, ਪਰ ਤੁਹਾਡੇ ਟਿਕਾਣੇ ਤੱਕ ਪਹੁੰਚ ਤੋਂ ਬਿਨਾਂ ਅਸੀਂ ਤੁਹਾਡਾ ਚੈੱਕ-ਇਨ ਪੂਰਾ ਨਹੀਂ ਕਰ ਸਕਦੇ। ਜਾਰੀ ਰੱਖਣ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਟਿਕਾਣੇ ਤੱਕ ਪਹੁੰਚ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ। ਅਸੀਂ ਤੁਹਾਡੇ ਟਿਕਾਣੇ ਦੀ ਵਰਤੋਂ ਸਿਰਫ਼ ਗੁਦਾਮ ਚੈੱਕ-ਇਨ ਦੇ ਮਕਸਦ ਲਈ ਕਰਦੇ ਹਾਂ ਅਤੇ ਇਸਨੂੰ ਕਿਸੇ ਤੀਜੀ ਧਿਰ ਨਾਲ ਸਟੋਰ ਜਾਂ ਸਾਂਝਾ ਨਹੀਂ ਕਰਦੇ।",
  "shareLocation": "ਮੇਰਾ ਟਿਕਾਣਾ ਸਾਂਝਾ ਕਰੋ"
}
